import React, { useContext, useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../navigation/Sidebar';
import Header from '../navigation/Header';
import AuthContext from '../../context/AuthContext';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const MainLayout = () => {
  const { user } = useContext(AuthContext);
  const [localUser, setLocalUser] = useState(null);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const navigate = useNavigate();
  
  // Get user from localStorage on mount
  useEffect(() => {
    console.log('MainLayout: Checking for user data in localStorage');
    
    // First check if token exists
    const token = localStorage.getItem('token');
    if (!token) {
      console.log('MainLayout: No token found, redirecting to login');
      navigate('/auth/login');
      return;
    }
    
    // If token exists, check for user data
    try {
      const userJson = localStorage.getItem('user');
      if (userJson) {
        const userData = JSON.parse(userJson);
        console.log('MainLayout: Found user in localStorage:', userData.name);
        setLocalUser(userData);
      } else if (user) {
        // Fallback to context user
        console.log('MainLayout: Using user from context:', user.name);
        setLocalUser(user);
      }
    } catch (error) {
      console.error('MainLayout: Error parsing user data from localStorage:', error);
      // If we have a user in context, use that
      if (user) {
        setLocalUser(user);
      }
    }
  }, [user, navigate]);
  
  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar with conditional classes for toggling */}
      <div 
        className={`transition-all duration-300 ease-in-out bg-primary-dark relative ${
          sidebarVisible ? 'w-64' : 'w-16'
        }`}
      >
        {/* Toggle button inside the sidebar */}
        <div className="absolute top-1/2 -mt-12 right-0 z-50 transform translate-x-1/2">
          <button
            className="flex items-center justify-center w-6 h-16 bg-primary text-white shadow-lg rounded-r-md hover:bg-primary-dark transition-all"
            onClick={() => setSidebarVisible(!sidebarVisible)}
            title={sidebarVisible ? "Show icons only" : "Show full menu"}
          >
            {sidebarVisible ? <FiChevronLeft size={14} /> : <FiChevronRight size={14} />}
          </button>
        </div>
        
        {/* Main sidebar content - switches between full and icon-only mode */}
        <Sidebar isExpanded={sidebarVisible} />
      </div>
      
      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header user={localUser || user} />
        
        {/* Page content */}
        <main className="flex-1 overflow-y-auto p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;